import {
  LIST_SERVICE_PRICE_REQUEST,
  LIST_SERVICE_PRICE_SUCCESS,
  LIST_SERVICE_PRICE_FAIL,
  LIST_SERVICE_PRICE_BRANCH_REQUEST,
  LIST_SERVICE_PRICE_BRANCH_SUCCESS,
  LIST_SERVICE_PRICE_BRANCH_FAIL,
  CREATE_SERVICE_PRICE_BRANCH_REQUEST,
  CREATE_SERVICE_PRICE_BRANCH_SUCCESS,
  CREATE_SERVICE_PRICE_BRANCH_FAIL,
  CANCEL_SERVICE_PRICE_BRANCH_REQUEST,
  CANCEL_SERVICE_PRICE_BRANCH_SUCCESS,
  CANCEL_SERVICE_PRICE_BRANCH_FAIL,
  DETAIL_SERVICE_PRICE_BRANCH_REQUEST,
  DETAIL_SERVICE_PRICE_BRANCH_SUCCESS,
  DETAIL_SERVICE_PRICE_BRANCH_FAIL,
  UPDATE_SERVICE_PRICE_BRANCH_REQUEST,
  UPDATE_SERVICE_PRICE_BRANCH_SUCCESS,
  UPDATE_SERVICE_PRICE_BRANCH_FAIL,
  DELETE_SERVICE_PRICE_BRANCH_REQUEST,
  DELETE_SERVICE_PRICE_BRANCH_SUCCESS,
  DELETE_SERVICE_PRICE_BRANCH_FAIL,
  IMPORT_SERVICE_PRICE_REQUEST,
  IMPORT_SERVICE_PRICE_SUCCESS,
  IMPORT_SERVICE_PRICE_FAIL,
  LIST_IMPORT_SERVICE_PRICE_REQUEST,
  LIST_IMPORT_SERVICE_PRICE_SUCCESS,
  LIST_IMPORT_SERVICE_PRICE_FAIL,
  LIST_DETAIL_IMPORT_SERVICE_PRICE_REQUEST,
  LIST_DETAIL_IMPORT_SERVICE_PRICE_SUCCESS,
  LIST_DETAIL_IMPORT_SERVICE_PRICE_FAIL,
  DETAIL_IMPORT_SERVICE_PRICE_REQUEST,
  DETAIL_IMPORT_SERVICE_PRICE_SUCCESS,
  DETAIL_IMPORT_SERVICE_PRICE_FAIL,
  EXPORT_IMPORT_SERVICE_PRICE_REQUEST,
  EXPORT_IMPORT_SERVICE_PRICE_SUCCESS,
  EXPORT_IMPORT_SERVICE_PRICE_FAIL,
  EXPORT_ALL_IMPORT_SERVICE_PRICE_REQUEST,
  EXPORT_ALL_IMPORT_SERVICE_PRICE_SUCCESS,
  EXPORT_ALL_IMPORT_SERVICE_PRICE_FAIL,
  RESET_SERVICE_PRICE_BRANCH
} from '../../constants/service-prices'

const initialState = {
  servicePrices: [],
  servicePriceBranch: {},
  servicePriceBranches: [],
  pageable: {
    page: 1,
    size: 10
  },
  loading: false,
  error: null,
  loadingDetail: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false
}

const servicePriceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_PRICE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePrices: action.payload,
        pageable: action.pageable
      }
    case LIST_SERVICE_PRICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        servicePrices: action?.dummy
      }
    case LIST_SERVICE_PRICE_BRANCH_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_PRICE_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePriceBranches: action.payload,
        pageable: action.pageable,
        servicePriceBranch: {}
      }
    case LIST_SERVICE_PRICE_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        servicePriceBranches: action?.dummy
      }
    case CREATE_SERVICE_PRICE_BRANCH_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_SERVICE_PRICE_BRANCH_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_SERVICE_PRICE_BRANCH_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case CANCEL_SERVICE_PRICE_BRANCH_REQUEST:
      return {
        ...state,
        loadingCancel: true
      }
    case CANCEL_SERVICE_PRICE_BRANCH_SUCCESS:
      return {
        ...state,
        loadingCancel: false
      }
    case CANCEL_SERVICE_PRICE_BRANCH_FAIL:
      return {
        ...state,
        loadingCancel: false,
        error: action.payload
      }
    case DETAIL_SERVICE_PRICE_BRANCH_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_SERVICE_PRICE_BRANCH_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        error: null,
        servicePriceBranch: action.payload
      }
    case DETAIL_SERVICE_PRICE_BRANCH_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        servicePriceBranch: action?.dummy
      }
    case UPDATE_SERVICE_PRICE_BRANCH_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SERVICE_PRICE_BRANCH_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        servicePriceBranch: {}
      }
    case UPDATE_SERVICE_PRICE_BRANCH_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_SERVICE_PRICE_BRANCH_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_SERVICE_PRICE_BRANCH_SUCCESS:
      return {
        ...state,
        loadingDelete: false
      }
    case DELETE_SERVICE_PRICE_BRANCH_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case IMPORT_SERVICE_PRICE_REQUEST:
      return { ...state, loadingImport: true }
    case IMPORT_SERVICE_PRICE_SUCCESS:
      return { ...state, loadingImport: false }
    case IMPORT_SERVICE_PRICE_FAIL:
      return { ...state, loadingImport: false, error: action.payload }
    case LIST_IMPORT_SERVICE_PRICE_REQUEST:
      return { ...state, loading: true }
    case LIST_IMPORT_SERVICE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePriceImport: action.payload,
        pageable: action?.pageable
      }
    case LIST_IMPORT_SERVICE_PRICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        servicePriceImport: action?.dummy
      }
    case LIST_DETAIL_IMPORT_SERVICE_PRICE_REQUEST:
      return { ...state, loading: true }
    case LIST_DETAIL_IMPORT_SERVICE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        detailServicePricesImport: action.payload,
        pageable: action.pageable
      }
    case LIST_DETAIL_IMPORT_SERVICE_PRICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        detailServicePricesImport: action?.dummy
      }
    case DETAIL_IMPORT_SERVICE_PRICE_REQUEST:
      return { ...state, loading: true }
    case DETAIL_IMPORT_SERVICE_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        detailServicePriceImport: action.payload
      }
    case DETAIL_IMPORT_SERVICE_PRICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        detailServicePriceImport: action?.dummy
      }
    case EXPORT_IMPORT_SERVICE_PRICE_REQUEST:
      return { ...state, loadingExport: true }
    case EXPORT_IMPORT_SERVICE_PRICE_SUCCESS:
      return { ...state, loadingExport: false }
    case EXPORT_IMPORT_SERVICE_PRICE_FAIL:
      return { ...state, loadingExport: false, error: action.payload }
    case EXPORT_ALL_IMPORT_SERVICE_PRICE_REQUEST:
      return { ...state, loadingExport: true }
    case EXPORT_ALL_IMPORT_SERVICE_PRICE_SUCCESS:
      return { ...state, loadingExport: false }
    case EXPORT_ALL_IMPORT_SERVICE_PRICE_FAIL:
      return { ...state, loadingExport: false, error: action.payload }
    case RESET_SERVICE_PRICE_BRANCH:
      return {
        ...state,
        servicePriceBranch: {}
      }
    default:
      return state
  }
}

export default servicePriceReducer
